import React from "react"
import moment from "moment"
import Link from "./link";
// import NewsletterForm from "./newsletter-form";

const YEAR = moment().format('YYYY');

export default function Footer() {
	return (
		<footer>
			<div className="container">
				{/* <NewsletterForm /> */}
				<Link to="/submit" className="btn">Submit</Link>
				<Link to="/about" className="btn">About</Link>
				<Link to="//twitter.com/hoverstates" className="btn">Twitter</Link>
				<Link to="//instagram.com/hoverstat.es" className="btn">Instagram</Link>
				<Link to="https://www.iubenda.com/privacy-policy/73367740" className="btn">Privacy Policy</Link>
				<p className="p1 outerx2">
					Copyright © {YEAR} <Link to="//official.business" className="underline">Official Business</Link>.
					All screenshots © of their respective owners.
				</p>
			</div>
		</footer>
	)
}
